import { Component, OnInit, inject } from '@angular/core';
import { DecimalPipe, DatePipe } from '@angular/common';
import {
  ProductsContractedService,
  ProductContractedRow,
} from '../../services/products-contracted.service';

const FREQ_LABEL: Record<string, string> = {
  mensual: 'Mensual',
  trimestral: 'Trimestral',
  anual: 'Anual',
  unico: 'Único',
};

@Component({
  selector: 'app-products-contracted-test',
  standalone: true,
  imports: [DecimalPipe, DatePipe],
  template: `
    <section style="padding: 2rem 0; background: #f8f9fa;">
      <div class="common-container">
        <h2 style="margin-bottom: 0.5rem;">
          🧪 Test: Productos contratados SaaS
        </h2>
        <p style="color: #666; margin-bottom: 1.5rem; font-size: 0.9rem;">
          BD: <code>ts_manager.producto_contratado</code>
        </p>

        @if (isLoading) {
          <p>Cargando...</p>
        } @else if (error) {
          <p style="color: red;">❌ {{ error }}</p>
        } @else if (rows.length === 0) {
          <p>No se encontraron registros.</p>
        } @else {
          <p style="margin-bottom: 1rem; color: #666;">
            {{ rows.length }} registro(s) encontrado(s)
          </p>
          <div style="overflow-x: auto;">
            <table
              style="width:100%; border-collapse: collapse; font-size: 0.82rem; background: #fff; box-shadow: 0 1px 4px rgba(0,0,0,.08);">
              <thead>
                <tr
                  style="background: var(--p-primary-color); color: #fff; text-align: left;">
                  <th style="padding: 8px 10px;">ID</th>
                  <th style="padding: 8px 10px;">Cliente</th>
                  <th style="padding: 8px 10px;">Concepto</th>
                  <th style="padding: 8px 10px;">Frecuencia</th>
                  <th style="padding: 8px 10px; text-align: right;">Precio</th>
                  <th style="padding: 8px 10px; text-align: right;">
                    Total + IVA
                  </th>
                  <th style="padding: 8px 10px;">Desde</th>
                  <th style="padding: 8px 10px;">Hasta</th>
                  <th style="padding: 8px 10px;">Estado</th>
                </tr>
              </thead>
              <tbody>
                @for (r of rows; track r.id; let even = $even) {
                  <tr [style]="'background:' + (even ? '#f9fafb' : '#fff')">
                    <td style="padding: 6px 10px; color: #999;">{{ r.id }}</td>
                    <td style="padding: 6px 10px;">{{ r.cliente_id }}</td>
                    <td
                      style="padding: 6px 10px; max-width: 220px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;"
                      [title]="r.concepto ?? ''">
                      {{ r.concepto ?? '—' }}
                    </td>
                    <td style="padding: 6px 10px;">
                      {{ freq(r.billing_frequency) }}
                    </td>
                    <td style="padding: 6px 10px; text-align: right;">
                      {{ r.precio | number: '1.2-2' }} {{ r.currency }}
                    </td>
                    <td style="padding: 6px 10px; text-align: right;">
                      @if (r.total_amount !== null) {
                        {{ r.total_amount | number: '1.2-2' }} {{ r.currency }}
                      } @else {
                        —
                      }
                    </td>
                    <td style="padding: 6px 10px; white-space: nowrap;">
                      {{ r.fecini | date: 'dd/MM/yyyy' }}
                    </td>
                    <td style="padding: 6px 10px; white-space: nowrap;">
                      {{ r.fecfin ? (r.fecfin | date: 'dd/MM/yyyy') : '∞' }}
                    </td>
                    <td style="padding: 6px 10px;">
                      @if (!r.activo) {
                        <span style="color:#dc2626;">Inactivo</span>
                      } @else if (r.is_suspended) {
                        <span style="color:#d97706;">Suspendido</span>
                      } @else if (r.is_cancelled) {
                        <span style="color:#6b7280;">Cancelado</span>
                      } @else {
                        <span style="color:#16a34a;">Activo</span>
                      }
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        }
      </div>
    </section>
  `,
})
export class ProductsContractedTestComponent implements OnInit {
  private service = inject(ProductsContractedService);

  rows: ProductContractedRow[] = [];
  isLoading = true;
  error: string | null = null;

  freq(f: string): string {
    return FREQ_LABEL[f] ?? f;
  }

  async ngOnInit(): Promise<void> {
    try {
      this.rows = await this.service.getProductsContracted();
    } catch (err: any) {
      this.error = err?.message ?? 'Error desconocido';
    } finally {
      this.isLoading = false;
    }
  }
}
